import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import withBaseComponent from '../../withBaseComponent';
import { connect }             from 'react-redux'
import {ToastContainer} from "react-toastify";
import ToastHelper from '../../../util/toast-helper'
import {mapDispatchToProps} from "../../mapDispatchToProps"
import LoadingModal from '../../common/LoadingModal'
import LoginLayout from '../layouts/LoginLayout'
import FiveZeroFour from '../errors/FiveZeroFour'
import $ from 'jquery'
import { initGA, logPageView } from "./GoogleAnalytics.js"

let isIME = false

class AppLayout extends withBaseComponent(React.Component) {
  hasMessage(){
    return this.props.message !== undefined && this.props.message.get('message') !== null
  }

  componentDidMount () {
    if (!window.GA_INITIALIZED) {
      initGA()
      window.GA_INITIALIZED = true
    }
    logPageView()
  }

  componentWillMount() {
    this.props.userActions.getUser().then(() => {
      setInterval(() => {
        // Promise ensure to wait until this action is responsed
        new Promise(() => this.props.sessionActions.refreshToken())
      }, 600000) // 10'
    })

    $( document ).ready(function() {
      $('body').keydown(function(e) {
        if (e.keyCode !== 27)
          return

        $('body').find('.popover').trigger('click')
      })

     $('body').on('compositionupdate', 'input', function(e) {
       isIME = true
     })

     $('body').on('keyup', 'input', function(e) {
       if (e.keyCode === 13 || e.keyCode === 27 || e.originalEvent.code === "Escape" || e.originalEvent.code === "Enter")
         isIME = false
     })

     $('body').on('blur', 'input', function(e) {
       isIME = false
     })

     $('body').keydown(function(e) {
       if (e.keyCode !== 27)
         return

       if (isIME === true) {
          isIME = false
          return
       }

       !isIME && $('body').find('.modal.show').find('button.close').trigger('click')
     })
   });
  }

  renderError504() {
    return (
      <LoginLayout>
        <FiveZeroFour />
      </LoginLayout>
    )
  }

  renderAppLayout() {
    const { isLoadingModal } = this.props;
    const options = {
      onOpen: () => {
        this.props.messageActions.setMessage({message: null});
      }
    };
    return (
      <div className='app-layout'>
        {this.hasMessage() && ToastHelper.message(this.props.message.toJS(), options)}
        <Header />
        <div className="container-fluid">
          <div className="row">
            <Sidebar />
            <div className="col-sm-10 container content">
              {this.props.isLoading &&
              <div className="fa-2x text-center">
                <i className="fas fa-spinner fa-spin"></i>
              </div>
              }

              <div className="row justify-content-md-center">
                {this.props.children}
              </div>

              <ToastContainer />
              <LoadingModal isProcessing={isLoadingModal} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    if(this.props.errorStatus === 504) {
      return this.renderError504()
    } else {
      return this.renderAppLayout()
    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.message,
    isLoadingModal: state.screen.get('isLoadingModal') || false,
    errorStatus: state.global.get('errorStatus')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
